import { Injectable, inject } from '@angular/core';

import { FsApi } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadData {
  private _api = inject(FsApi);


  public image(file): Observable<any> {
    return this._api.post('upload/image', { file }, { key: 'url' });
  }

}
